export enum AddOnProducts {
    wolandCore = 'WolandCore',
    wolandAdvanced = 'WolandAdvanced'
}
